export const playerTier = {
  tier: "Tier",
  playerTier: "Tier ผู้เล่น",
  operatorTierConfig: "การกำหนดค่า Operator Tier",
  name: "ชื่อ",
  addNewTier: "เพิ่ม Tier ใหม่",
  createNewTier: "สร้าง Tier ใหม่",
  minTurnover: "Turnover ขั้นต่ำ",
  maxTurnover: "TurnOver มากที่สุด",
  rewardAmount: "จำนวนรางวัล",
  rewardType: "ประเภทของรางวัล",
  isActive: "มีการใช้งานอยู่",
  activate: "เปิดใช้งาน",
  activated: "เปิดใช้งานแล้ว",
  updateTier: "แก้ไข Tier",
  startDate: "วันที่เริ่มต้น",
  endDate: "วันที่สิ้นสุด",
  duration: "ระยะเวลา",
  activationStatus:'สถานะการเปิดใช้งาน',
  updateTierConfig:'อัปเดตการกำหนดค่า Tier',
  cancel:'ยกเลิก'
};
